import { render } from "./TermsPolicyModal.vue?vue&type=template&id=48b07a25&scoped=true"
import script from "./TermsPolicyModal.vue?vue&type=script&lang=js"
export * from "./TermsPolicyModal.vue?vue&type=script&lang=js"

import "./TermsPolicyModal.vue?vue&type=style&index=0&id=48b07a25&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48b07a25"]])

export default __exports__